/**
 * Client market helpers — single place for REACT_APP_MARKET flags and families.
 *
 *   import { MARKET, isMarket, SAUDI_EGYPT_FAMILY, INDIA } from "../../core/market";
 *
 * Prefer `isMarket("SAUDI", "EGYPT")` or family flags over re-declaring
 * `process.env.REACT_APP_MARKET === "..."` in feature files.
 */

/**
 * Current market code from build env (uppercase), e.g. "SAUDI", "EASTEUROPE".
 * Read REACT_APP_MARKET directly — CRA/webpack inlines that member expression.
 * Do not gate on `process.env` alone; it can be undefined in the browser bundle
 * and would clear MARKET (hiding Raw File Upload type fields, etc.).
 */
export const MARKET = String(process.env.REACT_APP_MARKET || "")
  .trim()
  .toUpperCase();

/** Markets that load UI form config from GET /config. */
export const CONFIG_MARKETS = Object.freeze([
  "EASTEUROPE",
  "INDIA",
  "SAUDI",
  "SPAIN",
  "EGYPT",
  "BAHRAIN",
]);

/** True when `MARKET` matches any of the given codes (case-insensitive). */
export function isMarket(...names) {
  if (!MARKET) return false;
  return names.some((name) => MARKET === String(name || "").trim().toUpperCase());
}

/** True when this market uses API-driven Project / Supplier form config. */
export function usesApiMarketConfig(market = MARKET) {
  const code = String(market || "")
    .trim()
    .toUpperCase();
  return CONFIG_MARKETS.indexOf(code) !== -1;
}

// --- Individual market flags (build-time constants) ---
export const INDIA = isMarket("INDIA");
export const SPAIN = isMarket("SPAIN");
export const SAUDI = isMarket("SAUDI");
export const EGYPT = isMarket("EGYPT");
export const BAHRAIN = isMarket("BAHRAIN");
export const EASTEUROPE = isMarket("EASTEUROPE");

/**
 * Shared upload/batch behavior for Middle East markets that use the
 * server `saudi_egypt` type (Saudi, Egypt, Bahrain).
 */
export const SAUDI_EGYPT_FAMILY = isMarket("SAUDI", "EGYPT", "BAHRAIN");

/** localStorage key for auth state — unique per market deployment. */
export function getAuthStateKey() {
  if (SPAIN) return "IQVIA_SPAIN_AUTH_STATE";
  if (SAUDI) return "IQVIA_SAUDI_AUTH_STATE";
  if (EGYPT) return "IQVIA_EGYPT_AUTH_STATE";
  if (BAHRAIN) return "IQVIA_BAHRAIN_AUTH_STATE";
  if (EASTEUROPE) return "IQVIA_EASTEUROPE_AUTH_STATE";
  if (INDIA) return "IQVIA_INDIA_AUTH_STATE";
  return "IQVIA_AUTH_STATE";
}

export default {
  MARKET,
  CONFIG_MARKETS,
  isMarket,
  usesApiMarketConfig,
  INDIA,
  SPAIN,
  SAUDI,
  EGYPT,
  BAHRAIN,
  EASTEUROPE,
  SAUDI_EGYPT_FAMILY,
  getAuthStateKey,
};
